import { extractPercentageFromLabel, hasIGST } from "utils/functions/function";

interface Field {
  originalValue?: any;
  editFieldValue?: any;
}

export function extractVendorAddress(item: any) {
  try {
    if (!item || typeof item !== "object") return null;

    const label = item?.label;
    if (typeof label !== "string") return null;

    const parts = label?.split("->");
    if (parts.length < 2) return null;

    const afterArrow = parts[1]?.trim();
    return afterArrow && afterArrow.length > 0 ? afterArrow : null;
  } catch {
    return null;
  }
}

interface DataObject {
  [key: string]: any;
}

// export function transformDataForInitial(data: any): any {
//   // Helper function to get the final value
//   function getValue(field: any): any {
//     return field && field.editFieldValue !== null
//       ? field.editFieldValue
//       : field.originalValue;
//   }

//   // Recursive function to process nested objects and arrays
//   function processValue(value: any): any {
//     if (Array.isArray(value)) {
//       // Process each item in the array
//       return value.map((item: any) => processValue(item));
//     } else if (
//       value &&
//       typeof value === "object" &&
//       "originalValue" in value
//     ) {
//       // Return the final value for fields with originalValue and editFieldValue
//       return getValue(value);
//     } else if (value && typeof value === "object") {
//       // Process nested objects
//       return processObject(value);
//     } else {
//       // Return the value for primitives
//       return value;
//     }
//   }

//   // Recursive function to process objects
//   function processObject(obj: any): any {
//     let result: any = {};
//     for (const key in obj) {
//       if (obj.hasOwnProperty(key)) {
//         result[key] = processValue(obj[key]);
//       }
//     }
//     return result;
//   }

//   return processObject(data);
// }

// export function TransformDataFormField(values: any, originalValue : any) {
//     const changes: any = {};

//     // Helper function to handle nested values comparison
//     function compareValues(key: string, original: any, current: any, depth: number = 0): any {
//       const MAX_DEPTH = 10; // Set a maximum recursion depth to prevent infinite recursion

//       if (depth > MAX_DEPTH) {
//         return { error: 'Max depth exceeded' };
//       }

//       if (Array.isArray(original) && Array.isArray(current)) {
//         // Track changes in array items
//         const arrayChanges = current.reduce((acc: any[], item: any, index: number) => {
//           const originalItem = original[index];
//           const result = compareValues(`${key}[${index}]`, originalItem, item, depth + 1);

//           if (result && !result.error) {
//             acc.push({ index, result });
//           }
//           return acc;
//         }, []);

//         // Check if array length has changed
//         if (original.length !== current.length) {
//           arrayChanges.push({
//             lengthChanged: { originalLength: original.length, currentLength: current.length }
//           });
//         }

//         // If there are changes, return the entire array with changes
//         if (arrayChanges.length > 0) {
//           return {
//             originalValue: original,
//             editFieldValue: current,
//             changes: arrayChanges
//           };
//         }

//         return null;
//       } else if (typeof original === 'object' && original !== null && typeof current === 'object' && current !== null) {
//         // Handle object comparison
//         const nestedChanges: Record<string, any> = {};

//         // Check for changes in nested objects
//         Object.keys(current).forEach(nestedKey => {
//           const nestedOriginal = original[nestedKey];
//           const nestedCurrent = current[nestedKey];
//           const result = compareValues(`${key}.${nestedKey}`, nestedOriginal, nestedCurrent, depth + 1);
//           if (result && !result.error) {
//             nestedChanges[nestedKey] = result;
//           } else {
//             nestedChanges[nestedKey] = { originalValue: nestedOriginal, editFieldValue: nestedCurrent };
//           }
//         });

//         // Check for keys in the original that are missing in the current
//         Object.keys(original).forEach(nestedKey => {
//           if (!(nestedKey in current)) {
//             nestedChanges[nestedKey] = { originalValue: original[nestedKey], editFieldValue: null };
//           }
//         });

//         if (Object.keys(nestedChanges).length > 0) {
//           return nestedChanges;
//         }
//         return null;
//       } else if (typeof original === 'boolean' && typeof current === 'boolean') {
//         // Handle boolean value comparison
//         if (original !== current) {
//           return { originalValue: original, editFieldValue: current };
//         }
//         return null;
//       } else if (original !== current) {
//         // Handle primitive value comparison (excluding boolean handled above)
//         return { originalValue: original, editFieldValue: current };
//       } else {
//         return null;
//       }
//     }

//     // Compare all keys in the originalValue
//     Object.keys(originalValue).forEach(key => {
//       const originalValue = originalValue[key];
//       const currentValue = values[key];
//       const result = compareValues(key, originalValue, currentValue);

//       if (result && !result.error) {
//         changes[key] = result;
//       } else if (currentValue !== undefined) {
//         changes[key] = { originalValue: originalValue, editFieldValue: null };
//       }
//     });

//     // Include fields in `values` that are not in `originalValue`
//     Object.keys(values).forEach(key => {
//       if (!(key in changes)) {
//         const currentValue = values[key];
//         changes[key] = { originalValue: null, editFieldValue: currentValue };
//       }
//     });

//     console.log('---->>', changes);
//     if (Object.keys(changes).length > 0) {
//       return changes
//     }
//     else {
//       return {}
//     }
// }

export function transformDataForInitial(data: any): any {
  // Helper function to get the final value
  function getValue(field: any): any {
    return field && field.editFieldValue !== null
      ? field.editFieldValue
      : field.originalValue;
  }

  // Helper function to ensure field has both originalValue and editFieldValue
  function normalizeField(field: any): any {
    if (
      field &&
      typeof field === "object" &&
      ("originalValue" in field || "editFieldValue" in field)
    ) {
      return {
        originalValue:
          field.originalValue !== undefined ? field.originalValue : null,
        editFieldValue:
          field.editFieldValue !== undefined ? field.editFieldValue : null,
      };
    }
    return field;
  }

  // Recursive function to process nested objects and arrays
  function processValue(value: any): any {
    if (Array.isArray(value)) {
      // Process each item in the array
      return value.map((item: any) => processValue(item));
    } else if (
      value &&
      typeof value === "object" &&
      ("originalValue" in value || "editFieldValue" in value)
    ) {
      // Normalize field and return the final value
      const normalizedField = normalizeField(value);
      return getValue(normalizedField);
    } else if (value && typeof value === "object") {
      // Process nested objects
      return processObject(value);
    } else {
      // Return the value for primitives
      return value;
    }
  }

  // Recursive function to process objects
  function processObject(obj: any): any {
    let result: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = processValue(obj[key]);
      }
    }
    return result;
  }

  return processObject(data);
}

export function TransformDataFormField(values: any, originalValue: any) {
  const changes: any = {};

  // Helper function to handle nested values comparison
  function compareValues(
    key: string,
    original: any,
    current: any,
    depth: number = 0
  ): any {
    const MAX_DEPTH = 10; // Set a maximum recursion depth to prevent infinite recursion

    if (depth > MAX_DEPTH) {
      return { error: "Max depth exceeded" };
    }

    if (Array.isArray(original) && Array.isArray(current)) {
      // Track changes in array items
      const arrayChanges = current.reduce(
        (acc: any[], item: any, index: number) => {
          const originalItem = original[index];
          const result = compareValues(
            `${key}[${index}]`,
            originalItem,
            item,
            depth + 1
          );

          if (result && !result.error) {
            acc.push({ index, result });
          } else {
            acc.push({ originalValue: originalItem, editFieldValue: null });
          }
          return acc;
        },
        []
      );

      // Check for any items added or removed
      for (let i = current.length; i < original.length; i++) {
        arrayChanges.push({ originalValue: original[i], editFieldValue: null });
      }

      // If there are changes, return the entire array with changes
      if (arrayChanges.length > 0) {
        return {
          originalValue: original,
          editFieldValue: current,
          changes: arrayChanges,
        };
      }

      return null;
    } else if (
      typeof original === "object" &&
      original !== null &&
      typeof current === "object" &&
      current !== null
    ) {
      // Handle object comparison
      const nestedChanges: Record<string, any> = {};

      // Check for changes in nested objects
      Object.keys({ ...original, ...current }).forEach((nestedKey) => {
        const nestedOriginal = original[nestedKey];
        const nestedCurrent = current[nestedKey];
        const result = compareValues(
          `${key}.${nestedKey}`,
          nestedOriginal,
          nestedCurrent,
          depth + 1
        );

        if (result && !result.error) {
          nestedChanges[nestedKey] = result;
        } else if (nestedOriginal !== nestedCurrent) {
          nestedChanges[nestedKey] = {
            originalValue: nestedOriginal,
            editFieldValue: nestedCurrent,
          };
        } else {
          nestedChanges[nestedKey] = {
            originalValue: nestedOriginal,
            editFieldValue: null,
          };
        }
      });

      if (Object.keys(nestedChanges).length > 0) {
        return nestedChanges;
      }
      return null;
    } else if (original !== current) {
      // Handle primitive value comparison
      return { originalValue: original, editFieldValue: current };
    } else {
      return { originalValue: original, editFieldValue: null };
    }
  }

  // Compare all keys in the originalValue
  Object.keys({ ...originalValue, ...values }).forEach((key) => {
    const originalVal = originalValue[key];
    const currentValue = values[key];
    const result = compareValues(key, originalVal, currentValue);

    if (result && !result.error) {
      changes[key] = result;
    } else {
      changes[key] = {
        originalValue: originalVal,
        editFieldValue: currentValue !== originalVal ? currentValue : null,
      };
    }
  });

  // console.log("---->>", changes);
  if (Object.keys(changes).length > 0) {
    return changes;
  } else {
    return {};
  }
}

function transTablesValue(value: any | any): any {
  if (
    typeof value === "object" &&
    "originalValue" in value &&
    "editFieldValue" in value
  ) {
    return value.editFieldValue !== undefined &&
      value.editFieldValue !== "" &&
      value.editFieldValue !== null
      ? value.editFieldValue
      : value.originalValue;
  } else if (typeof value === "object") {
    const result: any = {};
    for (const key in value) {
      result[key] = transTablesValue(value[key]);
    }
    return result;
  } else {
    return value;
  }
}

export function transformTableValuesData(data: any): any[] {
  return data.map((item: any) => transTablesValue(item));
}

export function transformToOriginalAndEdited(data: any): any {
  function transformValue(value: any): any {
    return {
      originalValue: value,
      editFieldValue: null,
    };
  }

  function processValue(value: any): any {
    if (Array.isArray(value)) {
      return value.map((item: any) => transformValue(item));
    } else if (value && typeof value === "object") {
      return processObject(value);
    } else {
      return transformValue(value);
    }
  }

  function processObject(obj: any): any {
    let result: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        result[key] = processValue(obj[key]);
      }
    }
    return result;
  }
  return processObject(data);
}

export const checkTableTransformData = (values: any) => {
  const initialTables =
    values.length > 0
      ? Object.entries(values[values.length - 1]?.values?.tables).map(
        ([tableName, tableData]) => {
          return {
            [tableName]: transformTableValuesData(tableData),
          };
        }
      )
      : [];
  return initialTables || [];
};

export function validateLineItems(
  lineItems: any[],
  financialForm?: any,
  processName?: string
) {

  const errors: any = [];
  const formErrors: any = {};

  if (processName === "emerging") {
    if (!financialForm?.companyCode) {
      formErrors.companyCode = "Company Code is required.";
    }

    if (!financialForm?.gstVendorCode) {
      formErrors.gstVendorCode = "Vendor Code is required.";
    }

    if (!financialForm?.bukrs) {
      formErrors.bukrs = "Burks is required.";
    }

    if (!financialForm?.department) {
      formErrors.bukrs = "department is required.";
    }

    if (!financialForm?.invoiceType) {
      formErrors.invoiceType = "Invoice Type is required.";
    }

    if (!financialForm.vendorText) {
      formErrors.vendorText = "Vendor Text is required";
    }

    const remark = String(financialForm?.remark || "").trim();

    if (!remark) {
      formErrors.remark = "Remarks is required";
    } else if (remark.length > 50) {
      formErrors.remark = "Remarks cannot be greater than 50 characters";
    }

    if (financialForm?.isTdsApplicable) {
      if (financialForm?.tdsSectionType === "tds") {
        if (!financialForm?.tdsTaxCode) {
          formErrors.tdsTaxCode = "Tds Tax Code is required";
        }
      }
      if (financialForm?.tdsSectionType === "gl") {
        if (!financialForm?.glProfitCenter) {
          formErrors.glProfitCenter = "Gl Profit Center is required";
        }
        if (!financialForm?.glBusinessArea) {
          formErrors.glBusinessArea = "Gl Business Area is required";
        }
        if (!financialForm?.glAccount) {
          formErrors.glAccount = "Gl Account is required";
        }
        if (!financialForm?.glInternalOrder) {
          formErrors.glInternalOrder = "Gl Internal Order is required";
        }
        if (!financialForm?.glLineItemsRemark) {
          formErrors.glLineItemsRemark = "Gl Line item Remarks is required";
        } else if (financialForm?.glLineItemsRemark?.length > 50) {
          formErrors.glLineItemsRemark =
            "Gl Line Items Remarks cannot be greater than 50 characters";
        }
      }
    }

    if (Object.keys(formErrors).length > 0) {
      errors.push({ type: "financialForm", errors: formErrors });
    }
  }

  if (processName === "marcan") {
    if (!financialForm?.companyCode) {
      formErrors.companyCode = "Company Code is required.";
    }

    if (!financialForm?.gstVendorCode) {
      formErrors.gstVendorCode = "Vendor Code is required.";
    }

    if (!financialForm?.marcanApproval2) {
      formErrors.marcanApproval2 = "Approvals and Department";
    }

    if (!financialForm?.invoiceType) {
      formErrors.invoiceType = "Invoice Type is required.";
    }

    if (!financialForm.vendorText) {
      formErrors.vendorText = "Vendor Text is required";
    }

    const remark = String(financialForm?.remark || "").trim();

    if (!remark) {
      formErrors.remark = "Remarks is required";
    } else if (remark.length > 50) {
      formErrors.remark = "Remarks cannot be greater than 50 characters";
    }

    if (financialForm?.isTdsApplicable) {
      if (financialForm?.tdsSectionType === "tds") {
        if (!financialForm?.tdsTaxCode) {
          formErrors.tdsTaxCode = "Tds Tax Code is required";
        }
      }
      if (financialForm?.tdsSectionType === "gl") {
        if (!financialForm?.glProfitCenter) {
          formErrors.glProfitCenter = "Gl Profit Center is required";
        }
        if (!financialForm?.glBusinessArea) {
          formErrors.glBusinessArea = "Gl Business Area is required";
        }
        if (!financialForm?.glAccount) {
          formErrors.glAccount = "Gl Account is required";
        }
        if (!financialForm?.glInternalOrder) {
          formErrors.glInternalOrder = "Gl Internal Order is required";
        }
        if (!financialForm?.glLineItemsRemark) {
          formErrors.glLineItemsRemark = "Gl Line item Remarks is required";
        } else if (financialForm?.glLineItemsRemark?.length > 50) {
          formErrors.glLineItemsRemark =
            "Gl Line Items Remarks cannot be greater than 50 characters";
        }
      }
    }

    if (Object.keys(formErrors).length > 0) {
      errors.push({ type: "financialForm", errors: formErrors });
    }
  }

  if (processName === "tillomed") {
    if (!financialForm?.companyCode) {
      formErrors.companyCode = "Company Code is required.";
    }

    if (!financialForm?.gstVendorCode) {
      formErrors.gstVendorCode = "Vendor Code is required.";
    }


    if (!financialForm?.tillomedApproval) {
      formErrors.marcanApproval2 = "Please Select Bussiess And Department";
    }

    if (!financialForm?.invoiceType) {
      formErrors.invoiceType = "Invoice Type is required.";
    }

    if (!financialForm.vendorText) {
      formErrors.vendorText = "Vendor Text is required";
    }

    const remark = String(financialForm?.remark || "").trim();

    if (!remark) {
      formErrors.remark = "Remarks is required";
    } else if (remark.length > 50) {
      formErrors.remark = "Remarks cannot be greater than 50 characters";
    }

    if (financialForm?.isTdsApplicable) {
      if (financialForm?.tdsSectionType === "tds") {
        if (!financialForm?.tdsTaxCode) {
          formErrors.tdsTaxCode = "Tds Tax Code is required";
        }
      }
      if (financialForm?.tdsSectionType === "gl") {
        if (!financialForm?.glProfitCenter) {
          formErrors.glProfitCenter = "Gl Profit Center is required";
        }
        if (!financialForm?.glBusinessArea) {
          formErrors.glBusinessArea = "Gl Business Area is required";
        }
        if (!financialForm?.glAccount) {
          formErrors.glAccount = "Gl Account is required";
        }
        if (!financialForm?.glInternalOrder) {
          formErrors.glInternalOrder = "Gl Internal Order is required";
        }
        if (!financialForm?.glLineItemsRemark) {
          formErrors.glLineItemsRemark = "Gl Line item Remarks is required";
        } else if (financialForm?.glLineItemsRemark?.length > 50) {
          formErrors.glLineItemsRemark =
            "Gl Line Items Remarks cannot be greater than 50 characters";
        }
      }
    }

    if (Object.keys(formErrors).length > 0) {
      errors.push({ type: "financialForm", errors: formErrors });
    }
  }

  if (processName === "domestic" || processName === "zuventus") {
    if (!financialForm?.companyCode) {
      formErrors.companyCode = "Company Code is required.";
    }

    if (!financialForm?.gstVendorCode) {
      formErrors.gstVendorCode = "Vendor Code is required.";
    }

    if(processName === "domestic")
    {
    if (!financialForm?.domesticInitiator) {
      formErrors.marcanApproval2 = "Please Select Initiator";
    }
    }

    if (!financialForm?.invoiceType) {
      formErrors.invoiceType = "Invoice Type is required.";
    }

    if (!financialForm.vendorText) {
      formErrors.vendorText = "Vendor Text is required";
    }

    const remark = String(financialForm?.remark || "").trim();

    if (!remark) {
      formErrors.remark = "Remarks is required";
    } else if (remark.length > 50) {
      formErrors.remark = "Remarks cannot be greater than 50 characters";
    }

    if (financialForm?.isTdsApplicable) {
      if (financialForm?.tdsSectionType === "tds") {
        if (!financialForm?.tdsTaxCode) {
          formErrors.tdsTaxCode = "Tds Tax Code is required";
        }
      }
      if (financialForm?.tdsSectionType === "gl") {
        if (!financialForm?.glProfitCenter) {
          formErrors.glProfitCenter = "Gl Profit Center is required";
        }
        if (!financialForm?.glBusinessArea) {
          formErrors.glBusinessArea = "Gl Business Area is required";
        }
        if (!financialForm?.glPlantCode) {
          formErrors.glPlantCode = "Gl PlantCode is required";
        }
        if (!financialForm?.glBusinessPlace) {
          formErrors.glBusinessPlace = "Gl BusinessPlace is required";
        }
        if (!financialForm?.glAccount) {
          formErrors.glAccount = "Gl Account is required";
        }
        if (!financialForm?.glInternalOrder) {
          formErrors.glInternalOrder = "Gl Internal Order is required";
        }
        if (!financialForm?.glLineItemsRemark) {
          formErrors.glLineItemsRemark = "Gl Line item Remarks is required";
        } else if (financialForm?.glLineItemsRemark?.length > 50) {
          formErrors.glLineItemsRemark =
            "Gl Line Items Remarks cannot be greater than 50 characters";
        }
      }
    }

    if (Object.keys(formErrors).length > 0) {
      errors.push({ type: "financialForm", errors: formErrors });
    }
  }

  lineItems.forEach((item: any, index: number) => {
    const itemErrors: any = {};

    if (!item.plantCode?.value) {
      itemErrors.plantCode = "Plant Code is required.";
    }

    if (!item.businessPlace?.value) {
      itemErrors.businessPlace = "Bussiness Place is required.";
    }

    if (!item.costCenter?.value) {
      itemErrors.costCenter = "Cost center is required.";
    }

    if (!item.glAccount?.value) {
      itemErrors.glAccount = "GL account is required.";
    }



    // if (!item.taxCode?.value) {
    //   itemErrors.taxCode = "Tax code is required.";
    // }

    if (!item.businessArea?.value) {
      itemErrors.businessArea = "Bussiness is required";
    }

    if (!item.profitCenter?.value) {
      itemErrors.profitCenter = "Profit Center is Required";
    }

    const remark = String(item?.remark || "").trim();

    if (!remark) {
      itemErrors.remark = "Line item Remarks is required";
    } else if (remark.length > 50) {
      itemErrors.remark = "Remarks cannot be greater than 50 characters";
    }

    // if (!financialForm?.internalOrder) {
    //   formErrors.internalOrder = "Internal Order is required";
    // }

    if (Object.keys(itemErrors).length > 0) {
      errors.push({ index, errors: itemErrors });
    }
  });

  return errors;
}

export const toNum = (value: any): number => {
  if (value === null || value === undefined) return 0;
  const cleaned = String(value).replace(/,/g, "").trim();
  const num = Number(cleaned);
  return isNaN(num) ? 0 : num;
};


// export function customDecimalRoundSafe(value: number): number {
//   const [int, dec = "000"] = value.toFixed(3).split(".");
//   const roundedDec = (Math.round(Number(dec) / 10) * 10)
//     .toString()
//     .padStart(3, "0");
//   return Number(`${int}.${roundedDec}`);
// }

export function customDecimalRoundSafe(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export const customDecimalRoundSafeFunction = (n: any) =>
  Math.round((n + Number.EPSILON) * 100) / 100;



export function validateInvoiceTotals(
  ocrHeader: any,
  lineItems: any[],
  financialForm?: any,
  processName?: any
) {
  try {

    let tdsAmountData = 0
    console.log('the line items are', lineItems)
    let grandTotalBeforeTds = 0;
    let glCodeDescription = ""
    // Aggregation variables
    const amounts_as_per_gl_accounts: Record<string, number> = {};
    let all_tax_amounts = 0;

    (lineItems || []).forEach((item: any) => {
      console.log(item)
      const label = item?.taxCode?.label || "";
      const baseAmount = toNum(item?.Line_Amount);
      const hasIGSTVar = hasIGST(label);
      let percentage = 0

      const indicator = (item?.creditIndicator?.value || "").toString().trim().toLowerCase();
      const sign = indicator === "h" ? -1 : 1;

      // Extract GL Code for aggregation
      const glCode = item?.glAccount?.value || "Unknown";
      glCodeDescription = item?.glAccount?.label
      let taxOnThisLine = 0;

      const taxCodesArr = item?.taxCode?.taxCodes;
      const isTaxCodesEffectivelyEmpty =
        !Array.isArray(taxCodesArr) ||
        taxCodesArr.length === 0 ||
        taxCodesArr.every(
          (t: any) =>
            t === null ||
            t === undefined ||
            String(t).trim() === "" ||
            isNaN(parseFloat(String(t)))
        );


      if (processName === "marcan" && String(item?.taxCode?.value || "").toLowerCase() === "a1" && item?.taxJurisdiction?.label && isTaxCodesEffectivelyEmpty) {
        percentage = extractPercentageFromLabel(item?.taxJurisdiction?.label);
      }
      else {
        percentage = extractPercentageFromLabel(label);
      }

      if (isTaxCodesEffectivelyEmpty) {
        if (processName === "domestic" || processName === "zuventus") {
          if (hasIGSTVar) {
            // ✅ IGST → apply full percentage
            taxOnThisLine = customDecimalRoundSafe((baseAmount * percentage) / 100);
          } else {
            // ❌ CGST + SGST → split percentage into half
            const halfPercent = percentage / 2;
            const cgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
            const sgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
            taxOnThisLine = cgst + sgst;
          }
        }
        else {
          taxOnThisLine = customDecimalRoundSafe((baseAmount * percentage) / 100);
        }
      } else {
        const taxCodes = taxCodesArr || [];
        taxCodes.forEach((percent: any) => {
          if (
            percent !== "" &&
            percent !== null &&
            percent !== undefined
          ) {
            const p = parseFloat(percent.toString());
            if (!isNaN(p)) {
              const taxAmount =
                customDecimalRoundSafe((baseAmount * p) / 100);
              taxOnThisLine += taxAmount;
            }
          }
        });
      }
      const lineTotal = baseAmount + taxOnThisLine;
      grandTotalBeforeTds += lineTotal * sign;

      // Update Aggregations
      // GL aggregation: sum of (baseAmount * sign)
      const currentGlTotal = amounts_as_per_gl_accounts[glCode] || 0;
      amounts_as_per_gl_accounts[glCode] = currentGlTotal + (baseAmount * sign);

      // Global Tax Aggregation: sum of (taxOnThisLine * sign)
      all_tax_amounts = all_tax_amounts + (taxOnThisLine * sign);

      console.log({
        baseAmount,
        percentage,
        hasIGSTVar,
        taxOnThisLine,
        lineTotal,
        sign,
      });
    });

    console.log("the dsfsdfdfdfs  fdfs", amounts_as_per_gl_accounts)


    console.log({
      subtotal: 0,
      totalTax: 0,
      grandTotalBeforeTds: Number(grandTotalBeforeTds.toFixed(2))
    })

    // Step 3: TDS GL deduction — only if applicable
    const isTdsApplicable = financialForm?.isTdsApplicable === true;
    const tdsSectionType = financialForm?.tdsSectionType;
    const glAmount =
      isTdsApplicable && tdsSectionType === "gl"
        ? toNum(financialForm?.glAmount)
        : 0;

    const showGl = isTdsApplicable && tdsSectionType === "gl";

    // Final Grand Total = (Subtotal + Tax) - GL Amount

    tdsAmountData = showGl ? glAmount : financialForm?.tdsBasicAmount || 0;
    const finalGrandTotal = grandTotalBeforeTds - glAmount;

    // OCR Grand Total
    const ocrGrandTotal = toNum(ocrHeader?.Grand_Total);

    // Difference
    const difference = ocrGrandTotal - finalGrandTotal;
    const isValid = Math.abs(difference) <= 1;

    // Format for display - Dot Leader Style (Visual alignment for variable width fonts)
    // Combining Description and Type to reduce column misalignment issues
    const glRows = Object.entries(amounts_as_per_gl_accounts)
      .map(([gl, amt]: any) => {
        const typeLabel = amt < 0 ? 'Credit' : 'Debit';
        const itemWithLabel = (lineItems || []).find((it: any) => it?.glAccount?.value === gl);
        const glName = itemWithLabel?.glAccount?.label || "";
        console.log('the  gl anme are', glName)
        return `Line Amount ${glName} (${typeLabel}) ..................... ${Math.abs(amt).toFixed(2)}`;
      })
      .join("\n");

    const taxFormatted = typeof all_tax_amounts === 'number' ? all_tax_amounts.toFixed(2) : Number(all_tax_amounts).toFixed(2);
    const taxType = Number(all_tax_amounts) < 0 ? 'Credit' : 'Debit';

    // Error Message
    const errorMessage = false
      ? ""
      : `
${showGl ? "TDS GL DEDUCTION APPLIED\n" : ""}
VALIDATION SUMMARY
--------------------------------------------------
${typeof financialForm?.gstVendorCode?.label === "string"
        ? financialForm.gstVendorCode.label.split(" - ")[1]?.split(" -> ")[0]?.trim() || ""
        : ""} (${financialForm?.invoiceType?.label}) ........... ${ocrGrandTotal.toFixed(2)}
${glRows}
Tax (${taxType}) ............................. ${taxFormatted}
${!showGl
        ? `Tds Amount  ................................ ${extractPercentageFromLabel(financialForm?.tdsTaxCode?.label)
        }% of ${Number(tdsAmountData || 0)}
      = (${Number(tdsAmountData || 0)} × ${Number(extractPercentageFromLabel(financialForm?.tdsTaxCode?.label) || 0)
        } / 100)
      = ${(
          (Number(tdsAmountData || 0) *
            Number(extractPercentageFromLabel(financialForm?.tdsTaxCode?.label) || 0)) /
          100
        ).toFixed(2)}`
        : ""
      }
Roundoff ................................ ${difference.toFixed(2)}
--------------------------------------------------
Total Calculated ..................... ${finalGrandTotal.toFixed(2)}
Difference .............................. ${difference.toFixed(2)}

${isValid ? "STATUS: PASSED" : "STATUS: FAILED"}`;

    // Summary (GL only if applied)
    const summary = isValid
      ? showGl
        ? `Valid | TDS GL ₹${glAmount} deducted | Final: ₹${finalGrandTotal.toFixed(
          2
        )}`
        : `Valid | Final: ₹${finalGrandTotal.toFixed(2)}`
      : `Invalid | Difference: ₹${difference.toFixed(2)}`;

    return {
      subtotal: 0,
      totalTax: 0,
      grandTotalBeforeTds: Number(grandTotalBeforeTds.toFixed(2)),
      tdsGlDeduction: glAmount,
      finalGrandTotal: Number(finalGrandTotal.toFixed(2)),
      ocrGrandTotal: Number(ocrGrandTotal.toFixed(2)),
      difference: Number(difference.toFixed(2)),
      isValid,
      errorMessage,
      summary,
      amounts_as_per_gl_accounts,
      all_tax_amounts
    };
  } catch (err: any) {
    return {
      isValid: false,
      errorMessage: "Validation failed",
      exception: err.message,
    };
  }
}

// export function validateInvoiceTotals(
//   ocrHeader: any,
//   lineItems: any[],
//   financialForm?: any,
//   processName?:any
// ) {
//   try {
//     if(processName === "emerging")
//     {
//     let subtotal = 0;
//     let totalTax = 0;

//     // Only for showing in error message – no logic change
//     const lineSummaries: string[] = [];

//     (lineItems || []).forEach((item: any, index: number) => {
//       alert(JSON.stringify(item?.creditIndicator?.value))
//       const label = item?.taxCode?.label || "";

//        const indicator = (item?.creditIndicator?.value || "").toString().trim().toLowerCase();
//        const sign = indicator === "h" ? -1 : 1;
//       const rawAmount = toNum(item?.Line_Amount);
//       const baseAmount = sign * Math.abs(rawAmount);

//       const percentage = extractPercentageFromLabel(label);
//       const hasIGSTVar = hasIGST(label);

//       let taxOnThisLine = 0;

//       if (!Array.isArray(item?.taxCode?.taxCodes) || item?.taxCode?.taxCodes?.length === 0) {
//         if (hasIGSTVar) {
//           taxOnThisLine = customDecimalRoundSafe((baseAmount * percentage) / 100);
//         } else {
//           const halfPercent = percentage / 2;
//           const cgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
//           const sgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
//           taxOnThisLine = cgst + sgst;
//         }
//       } else {
//         const taxCodes = item?.taxCode?.taxCodes || [];
//         taxCodes.forEach((percent: number) => {
//           const taxAmount = customDecimalRoundSafe((baseAmount * percent) / 100);
//           taxOnThisLine += taxAmount;
//         });
//       }

//       subtotal += baseAmount;
//       totalTax += taxOnThisLine;

//       // ─── Just string for display ─── no new math
//       lineSummaries.push(
//         `Line ${ index + 1 }: ₹${ baseAmount.toFixed(2) } | ${ label || "No tax code" } | Tax ₹${ taxOnThisLine.toFixed(2) } `
//       );

//       console.log({
//         baseAmount,
//         percentage,
//         hasIGSTVar,
//         taxOnThisLine,
//       });
//     });

//     let grandTotalBeforeTds = subtotal + totalTax;

//     const isTdsApplicable = financialForm?.isTdsApplicable === true;
//     const tdsSectionType = financialForm?.tdsSectionType;
//     const glAmount =
//       isTdsApplicable && tdsSectionType === "gl"
//         ? toNum(financialForm?.glAmount)
//         : 0;

//     const showGl = isTdsApplicable && tdsSectionType === "gl";

//     const finalGrandTotal = grandTotalBeforeTds - glAmount;

//     const ocrGrandTotal = toNum(ocrHeader?.Grand_Total);

//     const difference = ocrGrandTotal - customDecimalRoundSafe(finalGrandTotal);
//     const isValid = Math.abs(difference) <= 1;

//     // Error message – now includes line summary only when FAILED
//     const errorMessage = isValid
//       ? ""
//       : `
// ${showGl ? "TDS GL DEDUCTION APPLIED\n" : ""}

// ──────────────────── LINE ITEMS ────────────────────
// ${lineSummaries.join("\n") || "(no lines)"}

// ───────────────────── SUMMARY ─────────────────────
// Subtotal (Base)                  : ₹${subtotal.toFixed(2)}
// Tax                              : ₹${totalTax.toFixed(2)}
// ----------------------------------------
// Grand Total (Before TDS GL)      : ₹${grandTotalBeforeTds.toFixed(2)}
// ${showGl ? `- TDS GL Amount                  : ₹${glAmount.toFixed(2)}\n` : ""}
// ${showGl ? "----------------------------------------\n" : ""}
// Final Grand Total ${showGl ? "(After TDS GL)" : ""} : ₹${finalGrandTotal.toFixed(2)}

// OCR Grand Total                  : ₹${ocrGrandTotal.toFixed(2)}
// Difference                       : ₹${difference.toFixed(2)}

// ${isValid ? "PASSED (±1 rupee allowed)" : "FAILED"}
// `;

//     const summary = isValid
//       ? showGl
//         ? `Valid | TDS GL ₹${glAmount} deducted | Final: ₹${finalGrandTotal.toFixed(2)}`
//         : `Valid | Final: ₹${finalGrandTotal.toFixed(2)}`
//       : `Invalid | Difference: ₹${difference.toFixed(2)}`;

//     return {
//       subtotal: Number(subtotal.toFixed(2)),
//       totalTax: Number(totalTax.toFixed(2)),
//       grandTotalBeforeTds: Number(grandTotalBeforeTds.toFixed(2)),
//       tdsGlDeduction: glAmount,
//       finalGrandTotal: Number(finalGrandTotal.toFixed(2)),
//       ocrGrandTotal: Number(ocrGrandTotal.toFixed(2)),
//       difference: Number(difference.toFixed(2)),
//       isValid,
//       errorMessage,
//       summary,
//     };
//   }
//   else
//   {
//     let subtotal = 0;
//     let totalTax = 0;

//     // Only for showing in error message – no logic change
//     const lineSummaries: string[] = [];

//     (lineItems || []).forEach((item: any, index: number) => {
//       alert(JSON.stringify(item?.creditIndicator))
//       const label = item?.taxCode?.label || "";

//       const baseAmount = toNum(item?.Line_Amount);
//       const percentage = extractPercentageFromLabel(label);
//       const hasIGSTVar = hasIGST(label);

//       let taxOnThisLine = 0;

//       if (!Array.isArray(item?.taxCode?.taxCodes) || item?.taxCode?.taxCodes?.length === 0) {
//         if (hasIGSTVar) {
//           taxOnThisLine = customDecimalRoundSafe((baseAmount * percentage) / 100);
//         } else {
//           const halfPercent = percentage / 2;
//           const cgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
//           const sgst = customDecimalRoundSafe((baseAmount * halfPercent) / 100);
//           taxOnThisLine = cgst + sgst;
//         }
//       } else {
//         const taxCodes = item?.taxCode?.taxCodes || [];
//         taxCodes.forEach((percent: number) => {
//           const taxAmount = customDecimalRoundSafe((baseAmount * percent) / 100);
//           taxOnThisLine += taxAmount;
//         });
//       }

//       subtotal += baseAmount;
//       totalTax += taxOnThisLine;

//       // ─── Just string for display ─── no new math
//       lineSummaries.push(
//         `Line ${index + 1}: ₹${baseAmount.toFixed(2)} | ${label || "No tax code"} | Tax ₹${taxOnThisLine.toFixed(2)}`
//       );

//       console.log({
//         baseAmount,
//         percentage,
//         hasIGSTVar,
//         taxOnThisLine,
//       });
//     });

//     let grandTotalBeforeTds = subtotal + totalTax;

//     const isTdsApplicable = financialForm?.isTdsApplicable === true;
//     const tdsSectionType = financialForm?.tdsSectionType;
//     const glAmount =
//       isTdsApplicable && tdsSectionType === "gl"
//         ? toNum(financialForm?.glAmount)
//         : 0;

//     const showGl = isTdsApplicable && tdsSectionType === "gl";

//     const finalGrandTotal = grandTotalBeforeTds - glAmount;

//     const ocrGrandTotal = toNum(ocrHeader?.Grand_Total);

//     const difference = ocrGrandTotal - customDecimalRoundSafe(finalGrandTotal);
//     const isValid = Math.abs(difference) <= 1;

//     // Error message – now includes line summary only when FAILED
//     const errorMessage = isValid
//       ? ""
//       : `
// ${showGl ? "TDS GL DEDUCTION APPLIED\n" : ""}

// ──────────────────── LINE ITEMS ────────────────────
// ${lineSummaries.join("\n") || "(no lines)"}

// ───────────────────── SUMMARY ─────────────────────
// Subtotal (Base)                  : ₹${subtotal.toFixed(2)}
// Tax                              : ₹${totalTax.toFixed(2)}
// ----------------------------------------
// Grand Total (Before TDS GL)      : ₹${grandTotalBeforeTds.toFixed(2)}
// ${showGl ? `- TDS GL Amount                  : ₹${glAmount.toFixed(2)}\n` : ""}
// ${showGl ? "----------------------------------------\n" : ""}
// Final Grand Total ${showGl ? "(After TDS GL)" : ""} : ₹${finalGrandTotal.toFixed(2)}

// OCR Grand Total                  : ₹${ocrGrandTotal.toFixed(2)}
// Difference                       : ₹${difference.toFixed(2)}

// ${isValid ? "PASSED (±1 rupee allowed)" : "FAILED"}
// `;

//     const summary = isValid
//       ? showGl
//         ? `Valid | TDS GL ₹${glAmount} deducted | Final: ₹${finalGrandTotal.toFixed(2)}`
//         : `Valid | Final: ₹${finalGrandTotal.toFixed(2)}`
//       : `Invalid | Difference: ₹${difference.toFixed(2)}`;

//     return {
//       subtotal: Number(subtotal.toFixed(2)),
//       totalTax: Number(totalTax.toFixed(2)),
//       grandTotalBeforeTds: Number(grandTotalBeforeTds.toFixed(2)),
//       tdsGlDeduction: glAmount,
//       finalGrandTotal: Number(finalGrandTotal.toFixed(2)),
//       ocrGrandTotal: Number(ocrGrandTotal.toFixed(2)),
//       difference: Number(difference.toFixed(2)),
//       isValid,
//       errorMessage,
//       summary,
//     };
//   }
//   } catch (err: any) {
//     return {
//       isValid: false,
//       errorMessage: "Validation failed",
//       exception: err.message,
//     };
//   }
// }
